import {Component, ComponentProps} from './Component';
import {Sprite as PixiSprite} from 'pixi.js';

export type SpriteProps = ComponentProps;
export class Sprite extends Component<SpriteProps, PixiSprite> {
    public readonly jsxType: string = 'sprite';

    public clone(): Sprite {
        return new Sprite(this.props);
    }

    public getConstructor(): new () => any {
        return PixiSprite;
    }
}
